import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import { ADD_EVENT_RESOURCE } from "../actions/types"
import {
  addEventResourceSuccess,
  addEventResourceError,
  readEventAvailableResourcesList,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

// add resource to event
function* requestMarkAll(action) {
  const {
    config: { eventUuid, resourceUuid, availableQuery },
  } = action
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${eventUuid}/resources`,
      method: `put`,
      data: [resourceUuid],
    })
    yield put(addEventResourceSuccess(action, response))
    yield put(
      readEventAvailableResourcesList({
        uuid: eventUuid,
        availableQuery,
      }),
    )
  } catch (error) {
    yield put(addEventResourceError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(ADD_EVENT_RESOURCE, requestMarkAll)
}
